import http from "./http-common";
import { getServidor } from "../utils/Utils";

/**
 * @class TiendaAciquiDataService
 * @brief Servicio para consumir los endpoints de la tienda ACIQUI.
 */
class TiendaAciquiDataService{
    
    /**
     * @brief Obtiene el archivo APK de la tienda ACIQUI para dispositivos Android.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP con el archivo APK en formato blob.
     */
    getAndroid() {
        
        return http.get(`${getServidor()}/tiendaAciqui/androidapk`, { responseType: 'blob' });
    }
}

export default new TiendaAciquiDataService();